import { Injectable } from "@angular/core";
import { io, Socket } from "socket.io-client";

@Injectable({
  providedIn: "root",
})
export class WebsocketProvider {
  socket: Socket;

  constructor() {
    this.socket = io(window.location.origin, {
      path: "/api/ws",
      withCredentials: true,
      transports: ["websocket"]
    });
  }

  on(eventName: string, callback: (...args: any[]) => void): void {
    this.socket.on(eventName, callback);
  }

  once(eventName: string, callback: (...args: any[]) => void): void {
    this.socket.once(eventName, callback);
  }

  emit(eventName: string, ...args: any[]): void {
    this.socket.emit.apply(this.socket, [eventName, ...args]);
  }

  off(eventName: string): void {
    this.socket.off(eventName);
  }
}
